/** Vaste klanttypen — productcontext / journey (verplicht bij nieuw project); geen interne termen in UI. */
export const CUSTOMER_TYPE_OPTIONS = [
  { id: 'particulier', label: 'Particulier' },
  { id: 'aannemer', label: 'Aannemer / bouwbedrijf' },
  { id: 'werkvoorbereider', label: 'Werkvoorbereider' },
  { id: 'projectontwikkelaar', label: 'Projectontwikkelaar' },
  { id: 'vastgoedontwikkelaar', label: 'Vastgoedontwikkelaar' },
  { id: 'woningcorporatie', label: 'Woningcorporatie' },
  { id: 'vve', label: 'VvE / appartementencomplex' },
  { id: 'huizenflipper', label: 'Huizenflipper / belegger' },
  { id: 'overheid', label: 'Overheid / gemeente' },
  { id: 'bank_financier', label: 'Bank / financier' },
  { id: 'adviseur', label: 'Adviseur / architect' },
  { id: 'anders', label: 'Anders' },
] as const;

export type CustomerTypeId = (typeof CUSTOMER_TYPE_OPTIONS)[number]['id'];

/**
 * Jaar van het prijsindexmandje in de bibliotheek (bouwprijspeil). Moet voorkomen in worker-seed `seedIndexValuesByYear`;
 * in deze codebase is dat momenteel alleen **2024** — vandaar deze default.
 */
export const DEFAULT_CALC_INDEX_YEAR = '2024';
